<app-card cardTitle="Basic Table" [options]="false" blockClass="table-border-style">
  <!-- Header Section -->
  <div class="row align-items-center mb-3 gx-2">
    <div class="col-9 col-md-6">
      <h5 class="mb-0 text-dark fw-bold">Add Sample</h5>
    </div>
  </div>

  <hr>

  <!-- Sample Form Starts -->
  <form [formGroup]="sampleForm" (ngSubmit)="submit()">
    <div class="row g-3">

      <!-- Category Dropdown -->
      <div class="col-md-12">
        <label class="form-label fw-semibold m-0">Choose Category</label>
        <ng-select [items]="categories" bindLabel="name" bindValue="_id" formControlName="categoryId"
          placeholder="Select Category"></ng-select>
        @if (sampleForm.get('categoryId')?.invalid && sampleForm.get('categoryId')?.touched) {
        <small class="text-danger">Category is required</small>
        }
      </div>

      <!-- Sample Name -->
      <div class="col-md-6">
        <div class="section-header"><span class="section-title">Sample Name</span></div>
        <input type="text" formControlName="name" class="form-control form-control-sm" placeholder="Enter Name">
        @if (sampleForm.get('name')?.invalid && (sampleForm.get('name')?.touched || sampleForm.get('name')?.dirty)) {
        <small class="text-danger">Name is required</small>
        }
      </div>

      <!-- Bar Code -->
      <div class="col-md-6">
        <div class="section-header"><span class="section-title">Bar Code</span></div>
        <input type="text" formControlName="sampleCode" class="form-control form-control-sm" placeholder="Bar Code">
        @if (sampleForm.get('sampleCode')?.invalid && sampleForm.get('sampleCode')?.touched) {
        <small class="text-danger">Bar Code is required</small>
        }
      </div>

      <!-- Video Title -->
      <div class="col-md-6">
        <div class="section-header"><span class="section-title">Video Title</span></div>
        <input type="text" formControlName="videoTitle" class="form-control form-control-sm" placeholder="Video Title">
      </div>


      <!-- Video Link -->
      <div class="col-md-6">
        <div class="section-header"><span class="section-title">Youtube Video Link</span></div>
        <input type="text" formControlName="videoLink" class="form-control form-control-sm" placeholder="Youtube Link">
      </div>



      <!-- Image Upload Section -->
      <div class="col-12 mb-4">
        <div class="section-header"><span class="section-title">Sample Images</span></div>
        <input type="file" id="file" class="form-control form-control-sm mt-1" multiple accept="image/*"
          (change)="getFileDetails($event)">
        <div class="text-primary">
          <i class="bi bi-info-circle me-1"></i>
          For best view, upload images in <strong>16:9 aspect ratio</strong>.
        </div>

        <!-- Preview List -->
        <div class="d-flex flex-wrap justify-content-start gap-3 my-1">
          @for (file of myFiles; track $index) {
          <div class="card shadow-sm" style="width: 120px; border: 1px solid #dee2e6;">
            @if (file.type.startsWith('image')) {
            <div class="position-relative" style="height: 100px;">
              <img [src]="file.url" [alt]="file.name" class="card-img-top img-fluid"
                style="height: 100%; object-fit: contain; border-bottom: 1px solid #dee2e6;">
            </div>
            } @else {
            <div class="d-flex flex-column justify-content-center align-items-center" style="height: 100px;">
              <i class="bi bi-file-earmark fs-1 text-muted"></i>
            </div>
            }
            <div class="card-footer bg-white border-top-0 px-2 py-2 d-flex justify-content-between align-items-center">
              <small class="text-truncate" style="max-width: 70%;" [title]="file.name">{{ file.name }}</small>
              <button type="button" class="btn btn-sm btn-outline-danger p-0 px-2" (click)="removeFile($index)"
                title="Delete" aria-label="Delete">&times;</button>
            </div>
          </div>
          }
        </div>
      </div>

      <!-- About Sample -->
      <div class="col-md-6 mb-4">
        <div class="section-header"><span class="section-title">About Sample</span></div>
        <editor [apiKey]="tinyAPiKey" formControlName="aboutSample" [init]="tinymceConfig"
          class="form-control form-control-sm" />
        @if (sampleForm.get('aboutSample')?.invalid && sampleForm.get('aboutSample')?.touched) {
        <small class="text-danger">About is required</small>
        }
      </div>

      <!-- Sample Description -->
      <div class="col-md-6 mb-4">
        <div class="section-header"><span class="section-title">Sample Description</span></div>
        <editor [apiKey]="tinyAPiKey" formControlName="description" [init]="tinymceConfig"
          class="form-control form-control-sm" />
      </div>

      <!-- Use Instructions -->
      <div class="col-md-6 mb-4">
        <div class="section-header"><span class="section-title">Use Instructions</span></div>
        <editor [apiKey]="tinyAPiKey" formControlName="usageInstructions" [init]="tinymceConfig"
          class="form-control form-control-sm" />
      </div>

      <!-- Ingredients -->
      <div class="col-md-6 mb-4">
        <div class="section-header"><span class="section-title">Sample Ingredients</span></div>
        <editor [apiKey]="tinyAPiKey" formControlName="ingredients" [init]="tinymceConfig"
          class="form-control form-control-sm" />
      </div>

      <!-- Quantity Limits Section -->
      <div class="col-12">
        <div class="section-header"><span class="section-title">Issues Limit</span></div>
        <div class="row g-2">
          <div class="col-md-3">
            <div class="limit-card">
              <label class="limit-label">Total Quantity</label>
              <input type="number" formControlName="totalItems" class="form-control form-control-sm" min="0">
            </div>
          </div>
          <div class="col-md-3">
            <div class="limit-card">
              <label class="limit-label">Wholesaler Limit</label>
              <input type="number" formControlName="maxIssueQuantityWholesaler" class="form-control form-control-sm"
                min="0">
            </div>
          </div>
          <div class="col-md-3">
            <div class="limit-card">
              <label class="limit-label">Retailer Limit</label>
              <input type="number" formControlName="maxIssueQuantityRetailer" class="form-control form-control-sm"
                min="0">
            </div>
          </div>
          <div class="col-md-3">
            <div class="limit-card">
              <label class="limit-label">Customer Limit</label>
              <input type="number" formControlName="maxIssueQuantityCustomer" class="form-control form-control-sm"
                min="0">
            </div>
          </div>
        </div>
      </div>

      <!-- Confirmation and Submit -->
      <div class="col-12 d-flex justify-content-between align-items-center pt-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" formControlName="confirm" />
          <label class="form-check-label small" for="confirmCheckbox">
            I confirm the details are correct
          </label>
        </div>

        <button type="submit" class="btn btn-primary btn-sm px-4 py-1" [disabled]="sampleForm.invalid">
          <i class="fas fa-paper-plane me-2"></i>Submit
        </button>
      </div>
    </div>
  </form>
</app-card>
